<div class="card-bg">
<div class="text-center mb-15">
  <img src="../../../../assets/logo.png"/>
</div>

<h1 id="title" class="title" *ngIf="!isCodeFormVisible">Login</h1>
<h1 id="title" class="title" *ngIf="isCodeFormVisible">Two-Factor Authentication</h1>
<p class="sub-title" *ngIf="!isCodeFormVisible">Please log in with your email to access your client space.</p>
  <p class="sub-title" *ngIf="isCodeFormVisible">
    A verification code has been sent to your email: <b>{{ loginForm.value.email }}</b>
  </p>

<nb-alert *ngIf="showMessages?.error && errors?.length && !submitted" outline="danger" role="alert">
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
  <p class="alert-title"><b>Success!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
  </ul>
</nb-alert>

<div [formGroup]="loginForm" aria-labelledby="title" *ngIf="!isCodeFormVisible">
  <div class="form-control-group">
    <span class="label-with-link">
      <label for="input-email" class="label">Email address:</label>
    </span>
    <input  nbInput
            fullWidth
            id="input-email"
            formControlName="email"
            [status]="email?.dirty ? (email?.invalid  ? 'danger' : 'success') : ''"
            [attr.aria-invalid]="email?.invalid && email?.touched ? true : null"
            placeholder="Email address"
            (keyup.enter)="loginForm.valid && !submitted && login()">
    <ngx-validation-message
      label="Email address"
      [showPattern]="email?.hasError('pattern') && email?.touched"
      [showRequired]="email?.errors?.required && email?.touched">
    </ngx-validation-message>
  </div>

  <div class="form-control-group">
    <span class="label-with-link">
      <label class="label" for="input-password">Password:</label>
      <a
          class="forgot-password caption-2"
          routerLink="../request-password">
        Forgot your password?
      </a>
    </span>

    <nb-form-field>
      <input
        nbInput
        fullWidth
        id="input-password"
        formControlName="password"
        [type]="getInputType()"
        [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : ''"
        placeholder="Password"
        (keyup.enter)="loginForm.valid && !submitted && login()">

      <button nbSuffix nbButton ghost (click)="toggleShowPassword()">
        <nb-icon
          [icon]="showPassword ? 'eye-outline' : 'eye-off-outline'"
          pack="eva"
          [attr.aria-label]="showPassword ? 'hide password' : 'show password'">
        </nb-icon>
      </button>

    </nb-form-field>

    <ngx-validation-message label="Password" [showMinLength]="password?.hasError('minlength') && password.touched"
      [showMaxLength]="password?.hasError('maxlength') && password.touched"
      [showRequired]="password?.errors?.required && password.touched"
      [minLength]="minLength"
      [maxLength]="maxLength"></ngx-validation-message>

  </div>

  <div class="form-control-group accept-group">
    <nb-checkbox formControlName="rememberMe" name="rememberMe" *ngIf="rememberMe">Remember me</nb-checkbox>
  </div>

  <button nbButton fullWidth status="primary" size="large"
   (click)="login()" [disabled]="submitted || !loginForm.valid"
    [class.btn-pulse]="submitted">
    Log In
  </button>
</div>

<div [formGroup]="otpForm" *ngIf="isCodeFormVisible" class="otp-form">

  <nb-alert *ngIf="otpError" outline="danger" role="alert">
    {{ otpError }}
  </nb-alert>

  <div class="form-control-group">
    <label for="input-otp" class="label">Enter verification code:</label>
    <input nbInput
           fullWidth
           id="input-otp"
           formControlName="code"
           placeholder="6-digit code"
           [status]="otp?.dirty ? (otp?.invalid ? 'danger' : 'success') : ''"
           (keyup.enter)="otpForm.valid && verifyOtp()">
    <ngx-validation-message
      label="OTP"
      [showRequired]="otp?.errors?.required && otp?.touched"
      [showPattern]="otp?.errors?.pattern && otp?.touched">
    </ngx-validation-message>
  </div>

  <button nbButton fullWidth status="primary" size="large"
          (click)="verifyOtp()"
          [disabled]="otpForm.invalid">
    Verify
  </button>

  <p class="resend-code">
    Didn't receive a code?
    <a
      href="#"
      (click)="!resending && resendOtp()"
      [class.disabled]="resending">
      Resend
    </a>
  </p>
</div>
<!--
<section class="another-action" aria-label="Register">
  Don't have an account? <a class="text-link" routerLink="../register">Register</a>
</section>-->

</div>
